import { render, staticRenderFns } from "./newGSA.vue?vue&type=template&id=77fe9528&"
import script from "./newGSA.vue?vue&type=script&lang=js&"
export * from "./newGSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports